import { combineReducers } from 'redux';

import device, * as fromDevice from './device';
import events, * as fromEvents from './events';
import identifiers, * as fromIdentifiers from './identifiers';
import interactions from './interactions';
import login, * as fromLogin from './login';
import privacy from './privacy';
import search, * as fromSearch from './search';
import session, * as fromSession from './session';
import trustedFunnel, * as fromTrustedFunnel from './trustedFunnel';
import ui, * as fromUI from './ui';

import type { MutationType } from '@web-platform/shared-universal-types/src/network/requestTypes';
import type { UserState } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user';

export default combineReducers<UserState>({
  device,
  events,
  identifiers,
  interactions,
  login,
  privacy,
  search,
  session,
  trustedFunnel,
  ui,
});

// Common selectors for user state
export const getDevice = (state: UserState) => fromDevice.get(state.device);
export const getIdentifiers = (state: UserState) => fromIdentifiers.get(state.identifiers);
export const getSession = (state: UserState, key: MutationType) =>
  fromSession.get(state.session, key);
export const getUserSearch = (state: UserState) => fromSearch.get(state.search);

// Acorn-specific selectors
export const getEvents = (state: UserState) => fromEvents.get(state.events);
// Banana-specific selectors
export const getLogin = (state: UserState) => fromLogin.get(state.login);
export const getTrustedFunnel = (state: UserState) => fromTrustedFunnel.get(state.trustedFunnel);
export const getUI = (state: UserState) => fromUI.get(state.ui);
